import AbstractValue from '@/models/app-config/behavior/abstract-value'

export interface RawBadgeConfig {
  label: string
  hidden?: boolean
}

export default class BadgeConfig extends AbstractValue<RawBadgeConfig> {
  get label(): string {
    return this.raw.label
  }
  get hidden(): boolean {
    return this.raw.hidden || false
  }
}
